/* 布局 */
//前台
import Layout from "@views/layout";

const userdailybehaviorstatsRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "userdailybehaviorstats/list",
        name: "USERDAILYBEHAVIORSTATS",
        meta: {
            title: "用户访问统计",
            keepAlive:true
        },
        component: () => import("@views/business/userdailybehaviorstats/index.vue"),
    },
        ],
};

export default userdailybehaviorstatsRouter;
